export default __webpack_public_path__ + "static/media/enable-dapp.25f1cdd8.png";